import * as types from '../types';
import GeneralService from '../../services/GeneralService';

const setCashoutBlockList = items => ({
    type: types.CASHOUT_BLOCK_LIST_RECEIVED,
    payload: items,
});

const setCashoutBlockMarketList = items => ({
    type: types.CASHOUT_BLOCK_MARKET_TEMPLATE,
    payload: items,
});

export const getAllBlockedCashout = params => async dispatch => {
    const { info, items } = await GeneralService.getAllBlockedCashout(params);

    if (info.success) {
        const sorted = [...items].sort((a, b) => b.id - a.id);
        dispatch(setCashoutBlockList(sorted));
    }

    return { info };
};

export const getAllBlockedCashoutMarkets = params => async dispatch => {
    const { info, items } = await GeneralService.getAllBlockedCashout(params);

    if (info.success) {
        const sorted = [...items].sort((a, b) => b.id - a.id);
        dispatch(setCashoutBlockMarketList(sorted));
    }

    return { info };
};

export const unblockTemplateCashout =
    ({ templateId, comment, operation }) =>
    async dispatch => {
        const response = await GeneralService.unblockCashout(templateId, { comment }, operation);
        return response;
    };

export const unblockTicketCashout =
    ({ templateId, comment, operation }) =>
    async dispatch => {
        const payload = {
            ticketId: templateId,
            comment,
            cashOutBlockTypes: operation,
        };
        const response = await GeneralService.unblockCashoutTicket(payload);
        return response;
    };

export const setUsedTournaments = payload => ({
    type: types.CASHOUT_BLOCK_TOURNAMENTS_CHANGED,
    payload,
});

export const setUsedMarkets = payload => ({
    type: types.CASHOUT_BLOCK_MARKETS_CHANGED,
    payload,
});

export const getUsedTournamentsAndMarkets = params => async dispatch => {
    const result = await GeneralService.getUsedTournamentsAndMarkets(params);

    dispatch(setUsedTournaments(result.item.tournaments));
    dispatch(setUsedMarkets(result.item.markets));

    return result;
};

export const updateCashoutMarket = (id, params) => async dispatch => {
    return await GeneralService.updateCashoutMarkets(id, params);
};
